import React from 'react';
import blueRadioActive from 'src/assets/icons/focus_state/blueRadioActive.svg';
import greyRadioInactive from 'src/assets/icons/not_focus/greyRadioInactive.svg';
import './BlueRadioButton.scss';

const BlueRadioButton = ({ checked, onChange, value, label }) => {
    return (
        <label className="blue-radio-button">
            <input
                type="radio"
                checked={checked}
                onChange={onChange}
                value={value}
                style={{ display: 'none' }}
            />
            <div className="radio-icon">
                <img
                    src={checked ? blueRadioActive : greyRadioInactive}
                    alt={checked ? 'Radio button selected' : 'Radio button unselected'}
                    width="22"
                    height="22"
                />
            </div>
            <span className="radio-label">{label}</span>
        </label>
    );
};

export default BlueRadioButton;